// 本地状态 + 弱网离线缓存（FR-3.3）：当前会话上下文与未发送草稿实时落 LocalStorage，
// 页面意外刷新（隧道/地铁）后可无损恢复。
import type { Script, Turn } from "./types";

const K = {
  user: "zr.userId",
  script: "zr.script",
  current: "zr.currentSession",
  turns: (sid: string) => `zr.turns.${sid}`,
  draft: (sid: string) => `zr.draft.${sid}`,
};

function lsGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}
function lsSet(key: string, val: string): void {
  try {
    window.localStorage.setItem(key, val);
  } catch {
    /* 隐私模式 / 配额满：降级为不缓存 */
  }
}
function lsDel(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* noop */
  }
}

export function uuid(): string {
  try {
    if (crypto?.randomUUID) return crypto.randomUUID();
  } catch {
    /* fall through */
  }
  return "x-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
}

export const store = {
  userId(): string {
    let id = lsGet(K.user);
    if (!id) {
      // 每浏览器独立匿名身份：各自只见自己创建的会话，互不可见。
      // 注意：仅本地标识，非真登录——换设备接不上、清缓存即丢。
      id = "u-" + uuid();
      lsSet(K.user, id);
    }
    return id;
  },

  script(): Script {
    return lsGet(K.script) === "zh-Hans" ? "zh-Hans" : "zh-Hant";
  },
  setScript(s: Script): void {
    lsSet(K.script, s);
  },

  currentSessionId(): string {
    let sid = lsGet(K.current);
    if (!sid) {
      sid = this.newSessionId();
      this.setCurrentSession(sid);
    }
    return sid;
  },
  setCurrentSession(sid: string): void {
    lsSet(K.current, sid);
  },
  newSessionId(): string {
    return "s-" + uuid().slice(0, 8) + Date.now().toString(36).slice(-4);
  },

  loadTurns(sid: string): Turn[] {
    const raw = lsGet(K.turns(sid));
    if (!raw) return [];
    try {
      const arr = JSON.parse(raw) as Turn[];
      // 不恢复「正在流式/出错」的半成品状态标记
      return arr.map((t) => ({ ...t, streaming: false }));
    } catch {
      return [];
    }
  },
  saveTurns(sid: string, turns: Turn[]): void {
    // 流式中也持续落盘，保证刷新不丢已生成内容
    lsSet(K.turns(sid), JSON.stringify(turns));
  },
  clearTurns(sid: string): void {
    lsDel(K.turns(sid));
  },

  draft(sid: string): string {
    return lsGet(K.draft(sid)) || "";
  },
  setDraft(sid: string, text: string): void {
    if (text) lsSet(K.draft(sid), text);
    else lsDel(K.draft(sid));
  },
};
